var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _c("dd-header"),
      _vm._v(" "),
      _c("div", { staticClass: "content_main" }, [
        _c("h1", [_vm._v("提案リスト")]),
        _vm._v(" "),
        _c("section", { staticClass: "propose_list" }, [
          _c("div", { staticClass: "propose" }, [
            _c("div", [_vm._v("\n          " + _vm._s(_vm.ID) + "\n        ")]),
            _vm._v(" "),
            _vm._m(0),
            _vm._v(" "),
            _c("div", [
              _vm._v("\n          " + _vm._s(_vm.price) + "\n        ")
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("dd-footer")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("div", [_c("span", [_vm._v("提案日")]), _vm._v(" "), _c("span")]),
      _vm._v(" "),
      _c("div", [_c("span", [_vm._v("提案カグラー")]), _vm._v(" "), _c("span")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-783f2c50", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-783f2c50","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/pages/ProposeList.vue
// module id = null
// module chunks = 